import React, { Component } from "react";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";
import { utilFunctions } from "../../../../_helpers"

const OperationTimeBarChart = (props) => {
    const INITIAL: any = []
    const [opTimeChartData, setOpTimeChartData] = React.useState(INITIAL);
    const [opTimeChartOptions, setOpTimeChartOptions] = React.useState({});

    React.useEffect(() => {
        let operationTimesChartX = [];
        let operationTimesChartY = [];
        if (!!props.data) {
            operationTimesChartX = props.data.x;
            operationTimesChartY = props.data.y;
        }
        setOpTimeChartData([
            {
                name: "Cycle Time",
                data: operationTimesChartY.map(val => utilFunctions.formatCycleTimes(val))
            }
        ])

        setOpTimeChartOptions({
            redrawOnParentResize: true,
            redrawOnWindowResize: true,
            chart: {
                toolbar: {
                    show: true,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: false,
                        zoomin: false,
                        zoomout: false,
                        pan: false,
                        reset: false,
                    }
                }

            },
            // colors: colors,
            plotOptions: {
                bar: {
                    borderRadius: 9,
                    columnWidth: '45%',
                    distributed: true,
                }
            },
            toolbar: {
                show: false
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: false
            },
            fill: {
                opacity: 1,
                colors: ['#f44336'],
            },
            xaxis: {
                categories: operationTimesChartX,
                labels: {
                    trim: true,
                    minHeight: 70,
                    maxHeight: 70,
                    style: {
                        fontSize: '12px'
                    }
                },
                title: {
                    text: 'CT',
                }
            },
            yaxis: {
                title: {
                    text: 'CT Time (sec)'
                },
                labels: {
                    formatter: (val) => utilFunctions.formatCycleTimes(val)
                },
            },
        })
    }, [props])

    return (
        <Chart options={opTimeChartOptions} series={opTimeChartData} type='bar' width={props.width} height={props.height} />
    )
}
OperationTimeBarChart.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    data: PropTypes.object.isRequired,
}

export default OperationTimeBarChart;
